import { View } from './view'

export const Mortgage = View
